import { getViewData } from './view-data';
import { loadScript } from '../helpers';

class GoogleService {
    /**
     * Load the google maps API
     *
     * @deprecated since YPS-7078.
     *
     * @returns {Promise}
     */
    loadMapsApi() {
        return loadScript({
            name: 'google-maps-api',
            src: `https://maps.googleapis.com/maps/api/js?key=${getViewData('env.GOOGLE_API_KEY')}&libraries=places`,
            when() {
                return window.google !== undefined;
            },
            return() {
                return window.google.maps;
            },
        });
    }

    /**
     * Load the google auth API
     *
     * @returns {Promise}
     */
    loadAuthApi() {
        return loadScript({
            name: 'google-auth-api',
            src: `//apis.google.com/js/platform.js`,
            when() {
                return window.gapi !== undefined;
            },
            return() {
                return window.gapi;
            },
        });
    }

    /**
     * Perform something after the method has loaded
     * and the initial events have setup
     *
     * @returns {Promise}
     */
    afterLoad(method = 'loadMapsApi') {
        return new Promise((resolve) => {
            this[method]().then((object) => {
                setTimeout(() => resolve(object), 0);
            });
        });
    }
}

export default new GoogleService();
